module.exports = __webpack_public_path__ + "static/media/beforeCompanyPics.b95d485d.jpg";